
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const bax2020r: IProductData = {
  id: "popeaudio-bax2020r",
  name: "BAX 2020R",
  description: "Baxendall BEAST style EQ and drive in 1U.",
  specialOrder: true,
  images: ["/img/popeaudio_bax_r_front.png", "/img/popeaudio_bax_r_back.png", "/img/popeaudio_bax_r_all.jpg"],
  details: [{
    label: "Description",
    markdown: `
Pope Audio BAX 2020R is a stereo/dual-mono version of the Pope's BAX2020 'Beast' version 500 series module which features an Avedis 1122 opamp input, with an Avedis 1122 opamp driving transformer output.  
It includes an additional switch, so the "HI" frequency point can be moved up to 40 kHz from the original 20 kHz.  
Additionally, the external power supply is ±18V DC, giving the unit another 6 dB of headroom over a standard 500 series unit.  
`
  }, {
    label: "Features",
    markdown: `
- Avedis 1122 input DOA (discrete op-amp)
- Avedis 1122 output DOA
- EA2623 Custom-made output Transformer
- True Bypass
- Hand-built in U.K.
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.popeaudio.co.uk/general-1-1-1" target="_blank">https://www.popeaudio.co.uk/general-1-1-1</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.EQ, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.ONE_U, HASHTAGS.RACK, HASHTAGS.MASTERING],
    manufacturer: BRAND.POPE_AUDIO,
  }
}